import React from 'react';

export default function Quote(props){

    return(
        <div className="quote">
            {props.quoteText}
        </div>
    );
}